// --- CLEAN + FIXED VERSION --- //

import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { query, where, collection, onSnapshot, getDocs } from "firebase/firestore";
import logo_default from "../../assets/logo_default.jpg";
import banner_default from "../../assets/banner_default.jpg";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from "../../components_root/ToastContext.jsx";
import { Randomcode } from "../../components_root/rendom_code.js"; 
import {
    MdArrowBackIos,
    MdClose,
    MdAccountCircle
} from "react-icons/md";

import { Uploader_files } from "../../components_root/uploader_files.js";
import { Update_voucher } from "../vouchers_root/Update_voucher.js";
import "./voucher_entry.css";
import AmountToWords from "../../components_root/AmountToWords.js";
import Ledger_accounts_profile from "../../company_root/staff_account_root/ledger_accounts_profile.jsx";
import { Randomnumber } from "../../components_root/rendom_number.js";

export const seo = {
    title: "aooz Services | Free & Premium Online Tools",
    description: "Discover free & premium online services on aooz.",
    keywords: "tools, seo, utilities",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};

// -----------------------
// FORMAT 13 DIGIT ACCOUNT NUMBER
// -----------------------
export function formatAccountNumber(num, length = 13) {
    if (!num) return "";
    return String(num).padStart(length, "0");
}

export default function Stock_voucher_entry({slug}) {
    const location = useLocation();
    const navigate = useNavigate();
    const { Toastshow } = Toast();
   const servicetablename = "accountingfinancedb";
    const [voucherid, setVoucherid] = useState(Randomcode(22));
    const [voucher, setVoucher] = useState("");
    const [voucher_type, setVoucher_type] = useState("");
    const [amount, setAmount] = useState("");
    const [totalamount, setTotalamount] = useState(0);
    const [description, setdescription] = useState("");
   // const [slug, setSlug] = useState("");
    const [voucherdate, setVoucherdate] = useState("");
    const [print, setPrint] = useState(false);

    const [fromsearchstatus, setFromsearchstatus] = useState(false);
    const [tosearchstatus, setTosearchstatus] = useState(false);

    const [from_accountguid, setFrom_accountguid] = useState("");
    const [to_accountguid, setTo_accountguid] = useState("");

    const [vouchersdata, setVouchersdata] = useState([]);
    const [ledger_accountsdata, setLedger_accountsdata] = useState([]);

    const [logo_file, setLogo_file] = useState(null);
    const [logoUrl, setLogoUrl] = useState("");
    const [old_file_uid, setOld_file_uid] = useState("");

    const [BannerUrl, setBannerUrl] = useState("");
    const [old_banner_file_uid, setOld_banner_file_uid] = useState("");

    const [companyData, setCompanyData] = useState([]);

    const receiptnumber = Randomnumber(13);
    const select_company_uid = Cookies.get("select_company_uid");

    // -----------------------
    // SET DATE
    // -----------------------
    useEffect(() => {
        setVoucherdate(new Date().toLocaleString());
    }, []);

    // -----------------------
    // GET SLUG FROM URL
    // -----------------------
    // useEffect(() => {
    //     const params = new URLSearchParams(location.search);
    //     const s = params.get("slug");
    //     if (s && s !== "null") setSlug(s);
    // }, [location.search]);

    // -----------------------
    // SAVE VOUCHER
    // -----------------------
    const handleCreate = async () => {
        if (!voucher.trim()) return Toastshow("Please enter voucher name.");
        if (!description.trim()) return Toastshow("Please enter description.");

        const payload = {
            voucherid,
            voucher_type,
            voucher,
            amount: Number(amount) || 0,
            description
        };

        const result = await Update_voucher(payload);

        if (result.success) Toastshow("Voucher saved successfully.");
        else Toastshow(result.error || "Failed to save voucher.");
    };

    // -----------------------
    // SEARCH FROM ACCOUNT #
    // -----------------------
    const handle_from_search_accountgnumber = async (accountnumber) => {
        if (!accountnumber) return setFromsearchstatus(false);

        try {
            const formatted = formatAccountNumber(accountnumber);

            const snap = await getDocs(
                query(
                    collection(db, servicetablename, select_company_uid, "ledger_accounts"),
                    where("accountnumber", "==", formatted)
                )
            );

            if (!snap.empty) {
                setFromsearchstatus(true);
                setFrom_accountguid(snap.docs[0].data().accountguid);
            } else {
                setFromsearchstatus(false);
            }
        } catch (e) {
            console.error(e);
            setFromsearchstatus(false);
        }
    };

    // -----------------------
    // SEARCH TO ACCOUNT #
    // -----------------------
    const handle_to_search_accountgnumber = async (accountnumber) => {
        if (!accountnumber) return setTosearchstatus(false);

        try {
 

            const snap = await getDocs(
                query(
                    collection(db, servicetablename, select_company_uid, "ledger_accounts"),
                    where("accountnumber", "==", accountnumber)
                )
            );

            if (!snap.empty) {
                setTosearchstatus(true);
                setTo_accountguid(snap.docs[0].data().accountguid);
            } else {
                setTosearchstatus(false);
            }
        } catch (e) {
            console.error(e);
            setTosearchstatus(false);
        }
    };

    // -----------------------
    // FETCH VOUCHER
    // -----------------------
    const fetchvouchers = async () => {
        if (!slug || !select_company_uid) return;

        const q = query(
            collection(db, servicetablename, select_company_uid, "vouchers"),
            where("slug", "==", slug)
        );

        const unsubscribe = onSnapshot(q, async (snapshot) => {
            const docs = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
            setVouchersdata(docs);

            const v = docs[0] || {};
            setVoucherid(v.voucherid || "");
            setVoucher(v.voucher || "");
            setdescription(v.description || "");
            setAmount(v.amount || "");
            setTotalamount(v.amount || 0);
            setOld_file_uid(v.logo_uid || "");
            setLogoUrl(v.logo_url || logo_default);

            fetchledger_accounts(v.voucherid);
        });

        return () => unsubscribe();
    };

    useEffect(() => {
        fetchvouchers();
    }, [slug]);

    // -----------------------
    // FETCH LEDGER ACCOUNTS
    // -----------------------
    const fetchledger_accounts = async (vid) => {
        if (!vid || !select_company_uid) return;

        const managerQ = query(
            collection(db, servicetablename, select_company_uid, "ledger_accounts_manager"),
            where("voucherid", "==", vid)
        );

        onSnapshot(managerQ, async (snap) => {
            if (snap.empty) return setLedger_accountsdata([]);

            const mgr = snap.docs[0].data();

            const accountsSnap = await getDocs(
                query(
                    collection(db, servicetablename, select_company_uid, "ledger_accounts"),
                    where("accountguid", "==", mgr.accountguid)
                )
            );

            const final = accountsSnap.docs.map((d) => ({
                ...d.data(),
                ledgertype: mgr.ledgertype,
                amount: mgr.amount
            }));

            setLedger_accountsdata(final);
        });
    };

    // -----------------------
    // COMPANY BANNER + LOGO
    // -----------------------
    const fetchCompanies = async () => {
        try {
            const snap = await getDocs(
                query(
                    collection(db, servicetablename),
                    where("uid", "==", select_company_uid)
                )
            );

            if (snap.empty) return;

            const doc = snap.docs[0].data();

            setBannerUrl(doc.banner_url || banner_default);
            setOld_banner_file_uid(doc.banner_uid || "");
            setLogoUrl(doc.logo_url || logo_default);
            setCompanyData(doc);
        } catch (e) {
            console.error("Company fetch error:", e);
        }
    };

    useEffect(() => {
        fetchCompanies();
    }, []);

    // -----------------------
    // AUTO UPLOAD LOGO
    // -----------------------
    useEffect(() => {
        const upload = async () => {
            if (!logo_file || !voucherid) return;

            const result = await Uploader_files({
                file: logo_file,
                servicetablename,
                fileuid: voucherid,
                editable: true,
                tablename: "vouchers",
                filename: "logo",
                old_file_uid
            });

            if (!result.success) return Toastshow(result.error);

            Toastshow("Successfully uploaded");
            setLogo_file(null);
            fetchvouchers();
        };

        upload();
    }, [logo_file]);

    // -----------------------
    // ESCAPE KEY → BACK
    // -----------------------
    useEffect(() => {
        const handle = (e) => e.key === "Escape" && navigate(-1);
        window.addEventListener("keydown", handle);
        return () => window.removeEventListener("keydown", handle);
    }, []);

    // ----------------------------------------------------
    // ----------------------- UI -------------------------
    // ----------------------------------------------------
    return (
        <div>
            {/* HEADER */}
            <div className="b-bottom">
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <div
                                    onClick={() => navigate("/?page=vouchers")}
                                    className="button-ui0 text-h2 bold p-2 cursor fcap"
                                >
                                    <MdArrowBackIos className="icon" /> {vouchersdata[0]?.voucher}
                                </div>
                            </td>
                            <td width={30}>
                                <div
                                    onClick={() => navigate("/?page=vouchers")}
                                    className="button-ui0 p-2 cursor"
                                >
                                    <MdClose className="icon" />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* DATE + RECEIPT */}
            <div className="b-bottom items-back-fill p-11">
                <table>
                    <tbody>
                        <tr>
                            <td className="text-h3"># {receiptnumber}</td>
                            <td width={160} className="text-h3 text-r">
                                Date: {voucherdate}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* BODY */}
            <div className="voucher-entry-body">
                <div className="ui-grid-4-equal m-top">
                    {/* FROM ACCOUNT */}
                    <div className="items-ui">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td width={25}>
                                                        <MdAccountCircle className="icon red" />
                                                    </td>
                                                    <td>
                                                        <div className="text-h2 bold fcap red">
                                                            From account (enter last 5 digits)
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <input
                                            placeholder="Search from account"
                                            onChange={(e) => {
                                                const c = e.target.value.replace(/[^0-9]/g, "");
                                                e.target.value = c;
                                                handle_from_search_accountgnumber(c);
                                            }}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <div className="items-back-fill rounded">
                                            {fromsearchstatus && (
                                                <Ledger_accounts_profile accountguid={from_accountguid} />
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* TO ACCOUNT */}
                    <div className="items-ui">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td width={25}>
                                                        <MdAccountCircle className="icon green" />
                                                    </td>
                                                    <td>
                                                        <div className="text-h2 bold green">
                                                            To account (enter last 5 digits)
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <input
                                            placeholder="Search to account"
                                            onChange={(e) => {
                                                const c = e.target.value.replace(/[^0-9]/g, "");
                                                e.target.value = c;
                                                handle_to_search_accountgnumber(c);
                                            }}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <div className="items-back-fill rounded">
                                            {tosearchstatus && (
                                                <Ledger_accounts_profile accountguid={to_accountguid} />
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* EMPTY */}
                    <div className="items-ui text-r"></div>

                    {/* AMOUNT */}
                    <div className="items-ui text-r">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="text-h2 cap">Amount</div>
                                    </td>
                                    <td width={20}>
                                        <span className="text-h1">₹</span>
                                    </td>
                                    <td width={150}>
                                        <input
                                            maxLength={20}
                                            className="p-1 bold text-h1"
                                            placeholder="Enter amount"
                                            value={amount}
                                            onChange={(e) => {
                                                let v = e.target.value.replace(/[^0-9.]/g, "");
                                                const p = v.split(".");
                                                if (p.length > 2) v = p[0] + "." + p.slice(1).join("");
                                                setAmount(v);
                                                setTotalamount(v);
                                            }}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* TOTAL */}
                <div className="ui-grid-4-equal m-top b-bottom">
                    <div className="items-ui"></div>
                    <div className="items-ui"></div>
                    <div className="items-ui"></div>

                    <div className="items-ui text-r">
                        <div className="items-back p-11">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div className="text-h2 cap bold">Total amount</div>
                                        </td>
                                        <td className="text-r">
                                            <span className="text-h1 bold">₹{totalamount}/-</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <AmountToWords amount={amount} />
                        </div>
                    </div>
                </div>

                {/* REMARKS AND PRINT */}
                <div className="ui-grid-4-equal m-top">
                    <div className="items-ui m-1">
                        <textarea
                            className="text-h3"
                            placeholder="Remark"
                            value={description}
                            onChange={(e) => setdescription(e.target.value)}
                        />
                    </div>

                    <div className="items-ui"></div>
                    <div className="items-ui p-3">
                        <label>
                            <input
                                type="checkbox"
                                checked={print}
                                onChange={(e) => setPrint(e.target.checked)}
                            />
                            <span className="text-h3">I want to save and print.</span>
                        </label>
                    </div>

                    <div className="items-ui m-1"></div>
                </div>
            </div>
        </div>
    );
}
